(function (angular) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyDealerInventory", [
    "$rootScope",
    "Location",
    "Dealer",
    "DealerInventoryService",
    "$q",
    "$timeout",
    "SitecoreAnalytics",
    "DealerSelector",
    "DebugLogger",
    function (
      $rootScope,
      Location,
      Dealer,
      DealerInventoryService,
      $q,
      $timeout,
      SitecoreAnalytics,
      DealerSelector,
      DebugLogger
    ) {
      function rejectHandler(error) {
        DebugLogger.log("tyDealerInventory", error);
      }

      var controller = [
        "$scope",
        function ($scope) {
          var ctl = this;
          var lastDealerInventoryRequest = null;

          ctl.init = function () {
            function updateHasDealer() {
              var dealer = Dealer.getSaved();
              $scope.hasDealer = dealer && dealer.branchCode;
              ctl.fetchUrl().catch(rejectHandler).finally(stopLoading);
            }

            $scope.$on("GeoPostCode", function (event, postcode) {
              startLoading();
              $scope.hasLocation = postcode !== "";
              ctl.fetchUrl().catch(rejectHandler);
            });

            $scope.$on("did-location-change-dealers-load-end", function () {
              updateHasDealer();
            });

            $scope.$on("dealer-saved-did-change", function () {
              updateHasDealer();
            });

            $scope.$watch("materialCode", function () {
              ctl.fetchUrl().catch(rejectHandler).finally(stopLoading);
            });
          };

          ctl.init();

          ctl.updateLoading = function (_loading) {
            $timeout(function () {
              $scope.loading = _loading;

              if (typeof $scope.onDidLoadingInitOrChange === "function") {
                $scope.onDidLoadingInitOrChange($scope.id, _loading);
              }
            });
          };

          function startLoading() {
            ctl.updateLoading(true);
          }

          function stopLoading() {
            ctl.updateLoading(false);
          }

          ctl.fetchUrl = function () {
            if (!ctl.hasAllData()) {
              return $q.reject("Can't fetchUrl() - this request requires location, dealer and materialCode");
            }

            $scope.error = false;

            DealerInventoryService.cancel(lastDealerInventoryRequest);

            var dealer = Dealer.getSaved();
            lastDealerInventoryRequest = DealerInventoryService.get(
              dealer,
              $scope.materialCode
            );

            return lastDealerInventoryRequest.then(function (response) {
              if (response && response.data) {
                var result = response.data;
                if (result.success) {
                  $scope.url = DealerInventoryService.urlWithCampaignTracking(
                    result.url,
                    $scope.utmMedium,
                    $scope.utmTerm
                  );
                } else {
                  $scope.error = true;
                }
              }
            });
          };

          ctl.hasAllData = function () {
            return $scope.hasLocation && $scope.hasDealer && !!$scope.materialCode;
          };

          ctl.checkLocalStock = function ($event) {
            if (!ctl.hasAllData()) {
              $event.preventDefault();
              $rootScope.$broadcast(
                "check-local-stock",
                $scope.materialCode,
                $scope.utmMedium,
                $scope.utmTerm,
                $scope.sitecoreAnalyticsGoalId
              );
              ctl.showChangeLocationModal();
            }

            if ($scope.error) {
              $event.preventDefault();
            }
          };

          ctl.showChangeLocationModal = function () {
            DealerSelector.openDealerSelector();
          };
        },
      ];

      return {
        scope: {
          materialCode: "<tyDealerInventoryMaterialCode",
          onDidLoadingInitOrChange:
            "<tyDealerInventoryOnDidLoadingInitOrChange",
          utmTerm: "@utmTerm",
          utmMedium: "@utmMedium",
          sitecoreAnalyticsGoalId: "@sitecoreAnalyticsGoalId",
        },
        restrict: "A",
        controller: controller,
        controllerAs: "tyDealerInventoryController",
        transclude: true,
        link: function (scope, element, attrs, ctrl, transclude) {
          transclude(scope, function (clone) {
            element.empty().append(clone);
          });

          angular.extend(scope, {
            loading: false,
            hasLocation: Location.get().postcode !== "",
            hasDealer: Dealer.getSaved().branchCode !== "",
            dealer: Dealer.getSaved(),
            error: false,
            url: "",
          });

          scope.tyDealerInventoryController.fetchUrl().catch(rejectHandler);
        },
      };
    },
  ]);
})(window.angular);
